var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{staticClass:"attachment_card primary",attrs:{"src":_vm.thumb_url}},[(_vm.editable)?_c('v-btn',{staticClass:"ma-3",attrs:{"small":"","fab":"","color":"secondary"},on:{"click":function($event){return _vm.$emit('delete')}}},[_c('v-icon',[_vm._v("mdi-delete")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }